export const FE_ONLY = (process.env.NEXT_PUBLIC_FRONTEND_ONLY || '0') === '1';
export const PORTAL_VERSION = process.env.NEXT_PUBLIC_PORTAL_VERSION || 'v0.0.0';
export const ENABLE_AUTH = (process.env.NEXT_PUBLIC_ENABLE_AUTH || '0') === '1';
export const SHOW_PORTAL_HOME = (process.env.NEXT_PUBLIC_SHOW_PORTAL_HOME || '0') === '1';
export const HOME_ROUTE = process.env.NEXT_PUBLIC_HOME || (SHOW_PORTAL_HOME ? '/portal' : '/docs');
export const CHANNEL_LABEL = process.env.NEXT_PUBLIC_CHANNEL_LABEL || 'Portal';
